// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';

export const Icon: StatelessFunctionalComponent<any> = styled(ClassOutlinedIcon)`
  &.MuiSvgIcon-root {
    font-size: 24px;
  }
`;
